import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("开启")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "APP配置" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.config,
          "label-col": { span: 2 },
          "wrapper-col": { span:8 },
          autocomplete: "off",
          onFinish: _ctx.onFinish
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "ios下载地址" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.config.line_ios,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.line_ios) = $event)),
                  placeholder: "请输入ios下载地址"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "android下载地址" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.config.line_android,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.line_android) = $event)),
                  placeholder: "请输入android下载地址"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "APP下载引导文案地址" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.config.download_doc,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.download_doc) = $event)),
                  placeholder: "请输入APP下载引导文案地址"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "是否弹出使用协议" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.config.agreement,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.agreement) = $event)),
                  name: "radioGroup"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "微信登录" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.config.wechat_login,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.config.wechat_login) = $event)),
                  name: "radioGroup"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { "wrapper-col": { offset: 2, span: 8 } }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "onFinish"])
      ]),
      _: 1
    })
  ]))
}